export const faqData = [
  {
    id: 1,
    question: "How often are new jobs added?",
    answer: "We update the job board every hour with fresh opportunities from top companies. Our automated system pulls directly from company career pages and verified sources, ensuring you get the latest openings as soon as they're posted."
  },
  {
    id: 2,
    question: "Are these jobs only for new grads?",
    answer: "While we focus on entry-level and new grad positions, we also feature internships and early-career roles (0-3 years experience). Perfect for students, recent graduates, and anyone starting their tech career journey."
  },
  {
    id: 3,
    question: "How do I filter jobs by location or remote?",
    answer: "Use the search bar and filters at the top of the job table. You can filter by location, remote/on-site preferences, job categories, and more. We've tagged each job to make finding your perfect match super easy."
  },
  {
    id: 4,
    question: "Which companies post jobs here?",
    answer: "We feature opportunities from FAANG companies (Google, Meta, Amazon, etc.), hot startups, and established tech firms. Currently tracking 100+ companies including Microsoft, Apple, Tesla, Uber, and many more."
  },
  {
    id: 5,
    question: "How can I get notified about new jobs?",
    answer: "Join our Discord community where we post real-time updates, or star our GitHub repository to get notifications. We're also building email alerts - coming soon!"
  },
  {
    id: 6,
    question: "Is this job board really free?",
    answer: "100% free, forever. This is a community-driven project to help new grads and students find opportunities. No hidden fees, no premium tiers, just free access to all job listings."
  },
  {
    id: 7,
    question: "How can I contribute or report issues?",
    answer: "This is an open-source project! You can contribute by submitting job listings, reporting broken links, or improving the codebase on our GitHub. Join our Discord community to connect with other job seekers and share tips."
  }
];